module.exports = __webpack_public_path__ + "img/feature_buy_freespin_th.cf18a733.png";